<template>
  <div>
    <div class="row">
      <b-form-group class="col-12 col-sm-8 col-md-9 col-lg-10"
        label="Endereço"
        label-for="address">

        <b-form-input id="address"
          type="text"
          :value="address.address"
          @input="updateForm('address', arguments[0])"
          placeholder="Logradouro"
          :class="{
            'is-invalid': form.errors.has('address.address'),
            'is-valid': !form.errors.has('address.address')
        }"></b-form-input>
      </b-form-group>

      <b-form-group class="col-12 col-sm-4 col-md-3 col-lg-2"
        label="Número"
        label-for="number">

        <b-form-input id="number"
          type="text"
          :value="address.number"
          @input="updateForm('number', arguments[0])"
          placeholder="Número"
          :class="{
            'is-invalid': form.errors.has('address.number'),
            'is-valid': !form.errors.has('address.number')
        }"></b-form-input>
      </b-form-group>

      <b-form-group class="col-12 col-sm-6 col-lg-3"
        label="Complemento"
        label-for="complement">

        <b-form-input id="complement"
          type="text"
          :value="address.complement"
          @input="updateForm('complement', arguments[0])"
          placeholder="Complemento"
          :class="{
            'is-invalid': form.errors.has('address.complement'),
            'is-valid': !form.errors.has('address.complement')
        }"></b-form-input>
      </b-form-group>

      <b-form-group class="col-12 col-sm-6 col-lg-3"
        label="Bairro"
        label-for="neighborhood">

        <b-form-input id="neighborhood"
          type="text"
          :value="address.neighborhood"
          @input="updateForm('neighborhood', arguments[0])"
          placeholder="Bairro"
          :class="{
            'is-invalid': form.errors.has('address.neighborhood'),
            'is-valid': !form.errors.has('address.neighborhood')
        }"></b-form-input>
      </b-form-group>

      <b-form-group class="col-12 col-sm-6 col-lg-2"
        label="CEP"
        label-for="zipcode">

        <b-form-input id="zipcode"
          type="text"
          :value="address.zipcode"
          @input="updateForm('zipcode', arguments[0])"
          placeholder="CEP"
          v-mask="'##.###-###'"
          :class="{
            'is-invalid': form.errors.has('address.zipcode'),
            'is-valid': !form.errors.has('address.zipcode')
        }"></b-form-input>
      </b-form-group>

      <b-form-group class="col-12 col-sm-6 col-lg-4"
        label="Cidade"
        label-for="city_id">

        <multiselect
          @search-change="searchCities"
          :loading="processingCities"
          :options="cities"
          v-model="city"
          track-by="id"
          label="name"
          placeholder="Pesquisar..."
          :limit="10"
          :hide-selected="false"
          :show-no-results="false"
          open-direction="bottom"
          :internal-search="false"
          :close-on-select="true"
          :clear-on-select="true"
          :showLabels="false">

          <template slot="clear" slot-scope="props">
            <div class="multiselect__clear"
              v-if="city !== null"
              @mousedown.prevent.stop="clearCity(props.search)">

              <i class="fa fa-times"></i>
            </div>
          </template>
        </multiselect>
      </b-form-group>
    </div>
  </div>
</template>

<script>
  import { get, set, clone, debounce, isEmpty } from 'lodash'
  import { resolveHTTP } from '@/services/api'

  export default {
    props: {
      form: {
        type: [Object],
        required: true
      }
    },

    data () {
      return {
        address: {},
        processingCities: false,
        selectedCity: null,
        citiesApi: null,
        cities: [],

        empty: {
          id: null,
          zipcode: '',
          address: '',
          number: '',
          complement: '',
          neighborhood: '',
          city_id: null,
          status: true
        }
      }
    },

    watch: {
      form: {
        handler (nextForm) {
          const self = this

          if (isEmpty(nextForm.address)) {
            self.$nextTick(() => {
              self.address = clone(self.empty)
              self.form.address = self.address
              self.selectedCity = null
            })
          }
        },
        deep: true
      }
    },

    computed: {
      city: {
        get () {
          return this.selectedCity || get(this.form, 'address.city', null)
        },

        set (value) {
          this.selectedCity = value
          this.updateForm('city_id', get(value, 'id', null))
        }
      }
    },

    methods: {
      updateForm (field, value) {
        set(this.address, field, value)
        set(this.form, `address.${field}`, value)
      },

      searchCities (searchQuery) {
        return this.debouncedSearchCities(searchQuery, this)
      },

      debouncedSearchCities: debounce((searchQuery, context) => {
        const self = context

        if (searchQuery) {
          self.processingCities = true

          self.citiesApi.index({ params: { search: searchQuery } })
            .then((res) => {
              self.processingCities = false
              self.cities = res.data.collection
            })
        }
      }, 500, { 'maxWait': 1000 }),

      clearCity (search) {
        this.city = null
      }
    },

    // mounted () {
    //   this.selectedCity = get(this.form, 'address.city', null)
    // },

    created () {
      this.selectedCity = get(this.form, 'address.city', null)
      this.citiesApi = resolveHTTP('/geo/cities')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/forms/Geo/AddressFields.vue